import React from 'react';

import { TableCell } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';

import { employeeNameFromSimpleContact } from '../../../../employees/utils/employee-name';
import { ICON_NAMES, MaterialDesignIcon } from '../../../../util/material-design-icons';

type InputProps = {
  messageDetail: AnnouncementDeliverabilityDetail;
};

export const LegacyPendingMessageRow = ({ messageDetail }: InputProps) => (
  <TableRow>
    <TableCell className="u-width-10">
      <MaterialDesignIcon iconName={ICON_NAMES.REMOVE} color="gray" />
    </TableCell>
    <TableCell colSpan={3} className="u-width-90">
      {employeeNameFromSimpleContact({
        nickname: messageDetail.nickname,
        firstName: messageDetail.firstName,
        lastName: messageDetail.lastName,
      })}
    </TableCell>
  </TableRow>
);
